module.exports = __webpack_public_path__ + "static/5-08673de3735c4c032fdd3896e3dbf84a.jpeg";